import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgContentDrop = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 9, height: 7, viewBox: "0 0 9 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { d: "M4.5 6.49902L0.602885 0.499024L8.39711 0.499024L4.5 6.49902Z", fill: "#F8F8FB" })
] });
const ForwardRef = /* @__PURE__ */ forwardRef(SvgContentDrop);
export { ForwardRef as ReactComponent };
import assetUrl from "/home/runner/work/UpstriveEducation-Teacher/UpstriveEducation-Teacher/src/assets/svg/contentDrop.svg?url";
export default assetUrl;
